import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";

class PaginationComponent extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }
    render(){
        return(
            <Pagination
                activePage={this.props.activePage}
                itemsCountPerPage = {100}
                totalItemsCount={this.props.data.count}
                onChange={this.props.handlePageChange}
            />
        )
    }
}

export default connect(null, null)(PaginationComponent);


// WEBPACK FOOTER //
// ./src/components/pagination.js